import React, { useState } from 'react';

import {
  ADD_CTA,
  CART_CTA,
  NOTIFY_ME_CTA,
} from 'hb-redux-store/constants/multipleSku';
import { getSelectedMultipleSkuIndex } from 'hb-redux-store/util/miscellaneousServices';
import { useCartDetails } from 'hb-redux-store/feature/cart/cart.hooks';
import { useInitialData } from 'hb-redux-store/initial.hooks';
import history from 'hb-redux-store/history';
import { useModalDetails } from 'hb-redux-store/feature/modal/modal.hooks';
import { usePDPDetails } from 'hb-redux-store/feature/products/product.hooks';

import Button from 'components/common/Button/Button';
import ButtonCounter from '../../common/Button/ButtonCounter';
import MultipleSkuList from './MultipleSkuList';
import ProductCard from '../ProductCard/ProductCard';

import './multiple-sku-bottom-sheet.scss';

const MultipleSkuBottomSheet = ({ product = {}, source = 'PLP' }) => {
  const skuActiveIndex = getSelectedMultipleSkuIndex(product?.skus);
  const [activeSkuIndex, setActiveSkuIndex] = useState(skuActiveIndex);
  const [currentSku, setCurrentSku] = useState(product?.skus[activeSkuIndex]);
  const [opInProgress, setOpInProgress] = useState(false);

  const { postAddItem, postRemoveItem, cartDetails } = useCartDetails();
  const { setAppNotification } = useInitialData();
  const { showMultipleSkuModal, showNonServiceableModal } = useModalDetails();
  const { initialData } = useInitialData();
  const {
    launchInfo: { loggedIn },
  } = initialData;
  const { notifyUser } = usePDPDetails();

  const skuCartQty =
    cartDetails?.cartSkus[currentSku.sku] ?? currentSku.inCartQuantity;
  const isCart = product?.source === 'cart';

  const successOpCb = msg => ({ sku: opSku, skuCount }) => {
    let sku = {};
    product.skus.map(s => {
      if (s.sku === opSku) {
        sku = { ...s, inCartQuantity: skuCount };
      }
    });
    setCurrentSku(sku);
    setOpInProgress(false);
    setAppNotification(msg);
  };

  const failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      setAppNotification(errorMessage);

    setOpInProgress(false);
  };

  const notify = () => {
    if (!loggedIn) {
      return setAppNotification('Please login to get notified.');
    }
    notifyUser({
      sku: currentSku?.sku,
      isCart,
      errorCb: e => {
        const message =
          e.data?.description ||
          e.data?.error?.errorMessage ||
          'Unable to process your request';
        if (e.status === 401) {
          setAppNotification('Please login to get notified.');
        }
        if (e.status === 500 && message === 'Please select a location.') {
          showNonServiceableModal({ visible: true, source: 'notifyMe' });
        }
      },
    });
  };

  const addToCart = async () => {
    await setOpInProgress(true);
    const atcData = {
      quantity: 1,
      productName: product?.productName,
      price: currentSku?.salePrice ?? currentSku?.retailPrice,
      source,
      productId: product.productId,
      sku: currentSku.sku,
      successOpCb: successOpCb('Item added to cart'),
      failOpCb: failOpCb('Error adding item to cart'),
      isCart,
    };
    postAddItem(atcData);
  };

  const removeFromCart = async () => {
    await setOpInProgress(true);
    const rfcData = {
      quantity: 1,
      productName: product?.productName,
      price: currentSku?.salePrice ?? currentSku?.retailPrice,
      source,
      productId: product.productId,
      sku: currentSku.sku,
      successOpCb: successOpCb('Item removed from cart'),
      failOpCb: failOpCb('Error removing item to cart'),
      isCart,
    };
    postRemoveItem(rfcData);
  };

  return (
    <div>
      <ProductCard
        product={product}
        source="multiple-sku"
        showDropDown={false}
        showButtonCounter={false}
        activeSkuIndex={activeSkuIndex}
      />
      <div className="multiple-sku-bottom-sheet--section-divider" />
      <div className="multiple-sku-bottom-sheet--list-wrapper ">
        <MultipleSkuList
          product={product}
          activeSkuIndex={activeSkuIndex}
          setActiveSkuIndex={index => {
            setActiveSkuIndex(index);
            setCurrentSku(product?.skus[index]);
          }}
        />
      </div>
      <div className="multiple-sku-bottom-sheet--bottom-cta bottom-sticky-cta">
        <div className="multiple-sku-bottom-sheet--cart-button">
          <Button
            className="button button-primary"
            onClick={() => {
              history.push('/cart');
              showMultipleSkuModal({
                visible: false,
                data: {},
              });
            }}
          >
            {CART_CTA}
          </Button>
        </div>
        <div className="multiple-sku-bottom-sheet--button-counter-wrapper">
          {!currentSku?.isInventoryAvailable && (
            <Button
              className="button action-link product-card--notify-me multiple-sku-bottom-sheet--button-height  multiple-sku-bottom-sheet--add-button"
              onClick={notify}
              disabled={opInProgress}
            >
              {NOTIFY_ME_CTA}
            </Button>
          )}
          {currentSku?.isInventoryAvailable && skuCartQty === 0 && (
            <Button
              className="button button-ghost multiple-sku-bottom-sheet--button-height  multiple-sku-bottom-sheet--add-button"
              onClick={addToCart}
              disabled={opInProgress}
            >
              {ADD_CTA}
            </Button>
          )}
          {currentSku?.isInventoryAvailable && skuCartQty > 0 && (
            <ButtonCounter
              className="button-counter-ghost full-width multiple-sku-bottom-sheet--button-height"
              onIncrement={addToCart}
              onDecrement={removeFromCart}
              disabled={opInProgress}
              counter={skuCartQty}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MultipleSkuBottomSheet;
